import React, {useEffect} from "react";
import {useTranslation} from "react-i18next";
import {SelectField} from "./FilterComponentStyles";
import {arrayAlphabeticalSort} from "../../../utils/helpers";
import {useStore} from "../../../hooks/useStore";
import {useFetch} from "hooks/useFetch";
import {toTurkishProperCase} from "utils/toTurkishProperCase";

const DynamicDistrictFilter = ({
    value,
    cityId,
    onChange,
    showLabel = true,
    valueKey = "_id",
    mode = undefined,
    selectMarginBottom = "20px",
    allowClear = false,
    placeholder = "",
    ...props
}) => {
    const {t} = useTranslation();
    const stores = useStore();
    const [districtLoading, districtData] = useFetch({
        defaultDataValue: {},
        fetchFn: stores.optionStore.getDistrictList.bind(null, {
            limit: 1000,
            sort: "name",
            cityId
        }),
        dependencies: [cityId],
        initialCall: false,
        waitForResponse: true,
        condition: cityId
    });

    return (
        <React.Fragment>
            {showLabel && <h5>{t("fields.county", {ns: "common"})}</h5>}
            <SelectField
                showSearch
                value={value}
                data-testid="district"
                mode={mode}
                onChange={onChange}
                mb={selectMarginBottom}
                allowClear={allowClear}
                placeholder={placeholder}
                loading={districtLoading}
                filterOption={(input, option) => {
                    return (
                        option?.["data-districtname"]
                            ?.toLocaleLowerCase("TR-tr")
                            ?.indexOf(input.toLocaleLowerCase("TR-tr")) >= 0
                    );
                }}
                {...props}
            >
                {arrayAlphabeticalSort([...(districtData?.data || [])]).map((district, i) => (
                    <SelectField.Option
                        data-testid="district_option"
                        key={i}
                        data-districtname={district.name}
                        value={district?.[valueKey]}
                    >
                        {toTurkishProperCase(district.name)}
                    </SelectField.Option>
                ))}
            </SelectField>
        </React.Fragment>
    );
};

export default DynamicDistrictFilter;
